export default __webpack_public_path__ + "static/template-team-member-2-eed5ac078500283a518ee78e2021fc53.jpg";